import { Link } from "react-router-dom";

interface Props {
  title: string;
  subtitle?: string;
  moreLink?: string;
  moreLabel?: string;
}

export default function SectionHeader({ title, subtitle, moreLink, moreLabel = "查看全部" }: Props) {
  return (
    <div className="flex items-end justify-between gap-4 mb-5">
      <div className="flex items-start gap-3">
        <span className="mt-1.5 w-1 h-6 rounded-full bg-accent-500 shrink-0" />
        <div>
          <h2 className="font-heading font-bold text-xl md:text-2xl text-foreground-950">{title}</h2>
          {subtitle && <p className="text-sm text-foreground-500 mt-1">{subtitle}</p>}
        </div>
      </div>
      {moreLink && (
        <Link
          to={moreLink}
          className="shrink-0 text-sm text-foreground-600 hover:text-accent-600 flex items-center gap-1 whitespace-nowrap transition-colors"
        >
          {moreLabel} <i className="ri-arrow-right-line" />
        </Link>
      )}
    </div>
  );
}